import { isMultiBiz } from '../../../../../../common/utils/accountUtils';
import { CompanySelectorWithHeaderText } from '../../../../../../components/CompanySelector/CompanySelectorWithHeaderText';
import { useAuth } from '../../../../AuthProvider';
import type { JSX } from 'react';

import './OrderSelectionPath.scss';

export interface OrderSubscriptionSelectionHeaderProps {
  breadCrumbs: JSX.Element;
}

export const OrderSubscriptionSelectionHeader = ({ breadCrumbs }: OrderSubscriptionSelectionHeaderProps) => {
  const { authenticatedUser } = useAuth();
  return (
    <>
      {isMultiBiz(authenticatedUser) ? (
        <div className="of-subscription-selection-nav">
          {breadCrumbs}
          <CompanySelectorWithHeaderText />
        </div>
      ) : (
        breadCrumbs
      )}
    </>
  );
};
